import { render } from "./App.vue?vue&type=template&id=24839a2c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=24839a2c&lang=css"
script.render = render

export default script